import {z} from 'zod';
import {
	editRemovesFromFilter,
	type EditRemovesFromFilterParams,
	getDefaultFilters,
	type GetDefaultFiltersParams,
	makeOptionalPropsNullable,
} from '@netx/core-schema';
import {
	BrandPortalField,
	type IBrandPortal,
	BrandPortalSchema,
} from './brandPortalSchema';

export const BrandPortalFilterSchema = makeOptionalPropsNullable(
	BrandPortalSchema.partial().pick({
		[BrandPortalField.label]: true,
		[BrandPortalField.path]: true,
	}),
);

export const SystemBrandPortalsFilterableField =
	BrandPortalFilterSchema.keyof().enum;

export const SYSTEM_BRAND_PORTALS_FILTERABLE_FIELDS = Object.values(
	SystemBrandPortalsFilterableField,
);

export type SystemBrandPortalsFilter = z.infer<typeof BrandPortalFilterSchema>;

/** will return the filters passed in if valid/specified, otherwise will return the defaults for the invalid/unspecified */
export const getSystemBrandPortalsDefaultFilters = (
	params?: Omit<
		GetDefaultFiltersParams<SystemBrandPortalsFilter>,
		'filterableFields'
	>,
): SystemBrandPortalsFilter =>
	getDefaultFilters({
		...params,
		filterableFields: SYSTEM_BRAND_PORTALS_FILTERABLE_FIELDS,
	});

/** given the original data, the new data, and the current filters, determine if the record should still be included in the filtered list */
export const portalEditRemovesFromFilter = (
	params: Omit<
		EditRemovesFromFilterParams<IBrandPortal, SystemBrandPortalsFilter>,
		'schema'
	>,
) =>
	editRemovesFromFilter({
		...params,
		schema: BrandPortalSchema,
	});
